// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

import plugins from './plugins' // plugins
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

/* 头部组件 */
import Header from './components/Header'
/* 尾部组件 */
import Footer from './components/Footer'
/* 回到顶部 */
import GoTop from './components/GoTop'
import Cookies from "js-cookie";
// 分页组件
import Pagination from "@/components/Pagination";

Vue.component(Header.name,Header)

Vue.component(Footer.name,Footer)

Vue.component(GoTop.name,GoTop)

Vue.component('Pagination', Pagination)

Vue.config.productionTip = false

Vue.use(plugins)

// Vue.use(Element, {
//   size: Cookies.get('size') || 'medium' // set element-ui default size
// })
Vue.use(Element)

router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});

Vue.prototype.isMobile = function() {
  console.log('userAgent:',navigator.userAgent);
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
};

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js